import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import feather from 'feather-icons';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class AnalyticsComponent implements OnInit {

  public ads: any[] = [];
  data: any;
  contractsData: any = []; // Initialize as empty array




  selectedInstallment: any;
  // editPaymentDateValue: string | null = null;
  editDateModalRef: any;
  
  
  @ViewChild('editDateModal') editDateModal!: TemplateRef<any>;
  
  selectedPayment: any = null;
  editPaymentDateValue: string = '';


  constructor( 
    private apisService: ApisService,
    private router: Router,
    public _translateService: TranslateService,
             private toastr : ToastrService,
                   private modalService: NgbModal
  ) {} 

  // Analytics boxes
  public investorsCount = 0;
  public partnersCount = 0;
  public totalInvestment = 0;
  public employeesCount = 0;
  public contractsCount = 0;
  public projectsCount = 0;

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public pages: any;
  public messages: any = {};
  public tempData = [];

  analyticsItems = [
    { icon: 'user-check', color: '#563825', title: 'Employees', value: this.employeesCount || 0 },
    { icon: 'file-text', color: '#d2ab66', title: 'Contracts', value: this.contractsCount || 0 },
    { icon: 'users', color: '#8B5E3C', title: 'Investors', value: this.investorsCount || 0 },
    { icon: 'briefcase', color: '#b58850', title: 'Partners', value: this.partnersCount || 0 },
    { icon: 'trending-up', color: '#8B5E3C', title: 'Investments', value: this.totalInvestment },
  ];

  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType; // Removed extra 'v' character

  ngOnInit(): void {
    this.getTags();
    this.getData();
    
    const currentUser = localStorage.getItem('currentUser');
    if (!currentUser) {
      this.router.navigate(['/pages/authentication/login-v2']);
    }
    
    this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this._translateService.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });
  }

  private setDatatableMessages() {
    this.messages = {
      emptyMessage: this._translateService.instant('MENU.DASHBOARD.no_data_available') || 'لا توجد بيانات متاحة',
      totalMessage: this._translateService.instant('MENU.DASHBOARD.total') || 'الإجمالي',
      selectedMessage: this._translateService.instant('MENU.DASHBOARD.selected') || 'محدد'
    };
  }

  getTags() {
    this.apisService.dashboard().subscribe({
      next: (response: any) => {
        const data = response || {};

        this.employeesCount = data.employees_count || 0;
        this.contractsCount = data.contracts_count || 0;
        this.investorsCount = data.investors_count || 0;
        this.partnersCount = data.partners_count || 0;
        this.totalInvestment = data.total_investment || 0;

        this.analyticsItems = [
          { icon: 'user-check', color: '#563825', title: 'Employees', value: this.employeesCount },
          { icon: 'file-text', color: '#d2ab66', title: 'Contracts', value: this.contractsCount },
          { icon: 'users', color: '#8B5E3C', title: 'Investors', value: this.investorsCount },
          { icon: 'briefcase', color: '#b58850', title: 'Partners', value: this.partnersCount },
          { icon: 'trending-up', color: '#8B5E3C', title: 'Investment', value: this.totalInvestment },
        ];

        // 🧠 Wait for DOM to update, then render icons
        setTimeout(() => feather.replace(), 0);
      },
      error: (error: any) => {
        console.error(error);
      },
    });
  }

  getData() {
    this.apisService.getContractOne().subscribe({
      next: (res) => {
        this.contractsData = res.data || [];
        this.tempData = [...this.contractsData]; // Initialize tempData for filtering
        console.log(this.contractsData, 'contractsData');
        
        // Refresh feather icons after data load
        setTimeout(() => feather.replace(), 0);
      },
      error: (error) => {
        console.error('Error fetching contracts:', error);
        this.contractsData = [];
      }
    });
  }
  

  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  goToContracts() {
    this.router.navigate(['/contracts']);
  }

  goToInvisitors() {
    this.router.navigate(['/investors']);
  }

  goToEmployees() {
    this.router.navigate(['/employees']);
  }

  goToPartners() {
    this.router.navigate(['/partners']);
  }

  filterUpdate(event: any) {
    const val = event.target.value.toLowerCase();
    
    // Filter the contracts data
    const filteredData = this.tempData.filter((contract: any) => {
      return (
        contract.serial_number?.toLowerCase().includes(val) ||
        contract.user_name?.toLowerCase().includes(val) ||
        contract.next_installment?.amount?.toString().includes(val)
      );
    });
    
    this.contractsData = filteredData;
    if (this.table) {
      this.table.offset = 0;
    }
  }

formatHijriDate(hijriDate: string): string {
  if (!hijriDate || hijriDate === '-') return '-';
  
  // تنظيف البيانات من أي مسافات زائدة
  const cleanedDate = hijriDate.trim();
  
  // إذا كان التاريخ يحتوي على أرقام إنجليزية (مشكلة في البيانات)
  if (/^[0-9\s]+$/.test(cleanedDate.replace(/[^0-9\s]/g, ''))) {
    return this.fixEnglishHijriDate(cleanedDate);
  }
  
  // إذا كان التاريخ بهيئة مختلطة مثل "11 1447 شعبان"
  return this.formatMixedHijriDate(cleanedDate);
}

private fixEnglishHijriDate(date: string): string {
  // تحويل الأرقام الإنجليزية إلى عربية إذا لزم الأمر
  const englishToArabic: { [key: string]: string } = {
    '0': '٠', '1': '١', '2': '٢', '3': '٣', '4': '٤',
    '5': '٥', '6': '٦', '7': '٧', '8': '٨', '9': '٩'
  };
  
  return date.split('').map(char => englishToArabic[char] || char).join('');
}

private formatMixedHijriDate(date: string): string {
  // تحسين تنسيق التاريخ مثل "11 1447 شعبان"
  const parts = date.split(' ');
  if (parts.length >= 3) {
    // ترتيب أكثر منطقية: اليوم - الشهر - السنة
    return `${parts[0]} ${parts[2]} ${parts[1]}`;
  }
  
  return date;
}

  addPayment(id:any): void {
    console.log('id from addPayment' , id)
    this.router.navigate(['/add-payments/', id]);
  }
  


  getInstallmentRatio(installment: any): string {
  const amount = Number(installment?.amount || 0);
  const max = Number(installment?.amount_max || 0);

  if (!max || max === 0) {
    return '0';
  }

  return ((amount / max) * 100).toFixed(1);
}

openEditDateModal(row: any): void {
  const installment = row?.next_installment;

  if (!installment?.payment_date || !installment?.id) {
    this.toastr.error(
      this._translateService.instant('MENU.DASHBOARD.NO_PAYMENT_DATE')
    );
    return;
  }

  // نخزن القسط نفسه
  this.selectedInstallment = installment;

  // نحط تاريخ القسط في input
  this.editPaymentDateValue = installment.payment_date;

  this.editDateModalRef = this.modalService.open(this.editDateModal, {
    centered: true,
    backdrop: 'static'
  });
}


submitEditDate(): void {
  if (!this.selectedInstallment || !this.editPaymentDateValue) return;

  const payload = {
    payment_date: this.editPaymentDateValue
  };

  this.apisService
    .addPaidInstallmentsContract(this.selectedInstallment.id, payload)
    .subscribe({
      next: () => {
        this.toastr.success(
          this._translateService.instant('MENU.DASHBOARD.DATE_UPDATED_SUCCESS')
        );

        this.editDateModalRef.close();
        this.getData(); // إعادة تحميل الجدول
      },
      error: (err) => {
        console.error(err);

        this.toastr.error(
          err?.error?.message ||
          this._translateService.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
        );
      }
    });
}


}